import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationListComponent } from '../admin/notification-list.component';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { Notification } from 'src/app/models/NotificationModel';

@Component({
  selector: 'cw-ci-notification-dashboard',
  templateUrl: './notification-dashboard.component.html',
  styleUrls: []
})
export class NotificationDashboardComponent implements OnInit {
  state='LIST';
  selectedNotification: Notification;

  @ViewChild(NotificationListComponent) notificationList: NotificationListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) { }

  ngOnInit() {
  }

  showAllNotifications() {
    this.selectedNotification = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch(event.state) {
      case 'CREATE':
        this.selectedNotification = new Notification();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedNotification = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedNotification = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
